import {
  INTERSECTION_CONFIG,
  type IntersectionCallbackType,
  type IntersectionConfigType,
  type IntersectionSlugType,
} from '@/defs/observer'

const INTERSECTION_CONFIGS = new Map<IntersectionSlugType, IntersectionConfigType>()

export const getIntersectionConfig = (slug: IntersectionSlugType) => {
  if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return
  if (!INTERSECTION_CONFIGS.has(slug)) {
    const callbacks = new WeakMap<Element, IntersectionCallbackType>()
    INTERSECTION_CONFIGS.set(slug, {
      callbacks,
      observer: new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const cb = callbacks.get(entry.target)
          if (cb) cb(entry)
        }
      }, INTERSECTION_CONFIG[slug]),
    })
  }
  return INTERSECTION_CONFIGS.get(slug)
}
